import PropTypes from 'prop-types';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { Switch, FormControlLabel } from '@mui/material';

// ----------------------------------------------------------------------

RHFSwitch.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func, // Added prop type for onChange
};

export default function RHFSwitch({ name, onChange, ...other }) {
  const { control } = useFormContext();

  // Modified render function to include onChange prop
  return (
    <FormControlLabel
      control={
        <Controller
          name={name}
          control={control}
          render={({ field }) => {
            const handleChange = (event,value) => {
              event.stopPropagation()
              onChange && onChange(event,value); // Invoke onChange prop if provided
              field.onChange(event); // Invoke field.onChange to update React Hook Form field value
            };

            return <Switch {...field} checked={field.value} onChange={handleChange} />;
          }}
        />
      }
      {...other}
    />
  );
}
